import React, { useEffect, useMemo, useState } from 'react'
import { Button, Spin, Modal, Form, Input, message } from 'antd'
import { addEstimateField, updateEstimateField } from '../../../services/estimate-field'
import DecimalInput from '../../DecimalInput'

const AddEstimateModal = ({ estimateId, estimateItem, onChancel, showModal, onSuccess }) => {
  const [form] = Form.useForm()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    form.resetFields()
  }, [estimateItem?.id])

  const initFields = useMemo(() => {
    return estimateItem
      ? {
          name: estimateItem.name,
          unit: estimateItem.unit,
          amount: estimateItem.amount,
          category: estimateItem.category,
          price: estimateItem.price,
          identifier: estimateItem.identifier,
        }
      : {}
  }, [estimateItem?.id])

  const onSaveHandler = (fields) => {
    setIsLoading(true)
    const data = {
      data: {
        estimate: estimateId,
        name: fields.name,
        unit: fields.unit,
        amount: fields.amount,
        category: fields.category,
        price: fields.price,
        identifier: fields.identifier,
      },
    }
    addEstimateField(data)
      .then(() => {
        message.success('Позиция успешно добавлена')
        onSuccess()
        onCancelHandler()
      })
      .catch(() => {
        message.error('Ощибка при добавлении позиции в смету')
      })
      .finally(() => setIsLoading(false))
  }

  const onUpdateHandler = (fields) => {
    setIsLoading(true)
    const data = {
      name: fields.name,
      unit: fields.unit,
      amount: fields.amount,
      category: fields.category,
      price: fields.price,
      identifier: fields.identifier,
    }

    updateEstimateField(estimateItem.id, data)
      .then(() => {
        message.success('Позиция успешно обновлена')
        onSuccess()
        onCancelHandler()
      })
      .catch(() => {
        message.error('Ощибка при обновлении позиции в смету')
      })
      .finally(() => setIsLoading(false))
  }

  const onCancelHandler = () => {
    form.resetFields()
    onChancel()
  }

  return (
    <Modal
      title={estimateItem ? 'Редактировать позицию' : 'Добавить новую позицию'}
      visible={showModal}
      onCancel={onCancelHandler}
      footer={[
        <Button key="back" onClick={onCancelHandler}>
          Отмена
        </Button>,
        <Button key="save" type="primary" onClick={() => form.submit()}>
          Сохранить
        </Button>,
      ]}
    >
      <Spin spinning={isLoading}>
        <Form
          name="new-estimate-item"
          initialValues={initFields}
          autoComplete="off"
          layout="vertical"
          form={form}
          onFinish={estimateItem ? onUpdateHandler : onSaveHandler}
        >
          <Form.Item
            label="Наименование"
            name="name"
            style={{ marginBottom: 5 }}
            rules={[{ required: true, message: 'Поле обязательно' }]}
          >
            <Input disabled={!!estimateItem?.id} />
          </Form.Item>
          <Form.Item
            label="Цена"
            name="price"
            style={{ marginBottom: 5 }}
            rules={[{ required: true, message: 'Поле обязательно' }]}
          >
            <DecimalInput />
          </Form.Item>
          <Form.Item
            label="Количество"
            name="amount"
            style={{ marginBottom: 5 }}
            rules={[{ required: true, message: 'Поле обязательно' }]}
          >
            <DecimalInput />
          </Form.Item>
          <Form.Item
            label="Единица измерения"
            name="unit"
            style={{ marginBottom: 5 }}
            rules={[{ required: true, message: 'Поле обязательно' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="Категория" name="category" style={{ marginBottom: 5 }}>
            <Input />
          </Form.Item>
          <Form.Item label="Идентификатор" name="identifier" style={{ marginBottom: 5 }}>
            <Input />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  )
}

export default AddEstimateModal
